import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_9: FaireProductEntity = {
  token: "toysmith-9",
  type: "product",
  name: "Funko Mystery Minis: One Piece",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/bf3be84ac79281758cb2db80dad557b8d67963842f7f6022db3c784e0ea45642.png?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 7.5,
  msrpDollars: 15,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
